/**
 * Keyword matching for auto-detecting product type from item descriptions.
 *
 * When staff types a custom item description (e.g., "red corsage for prom"),
 * this utility detects keywords and returns the matching product type
 * so the correct placeholder product is used for Shopify product_type tracking.
 */

const KEYWORD_MAP = [
  {
    productType: 'Boutonniere',
    keywords: ['boutonniere', 'bout'],
  },
  {
    productType: 'Corsage',
    keywords: ['corsage', 'wristlet'],
  },
  {
    productType: 'Wrap',
    keywords: ['wrap', 'hand-tied', 'hand tied', 'wrapped'],
  },
  {
    productType: 'Nosegay',
    keywords: ['nosegay', 'clutch'],
  },
  {
    productType: 'Bud Vase',
    keywords: ['bud vase', 'bud'],
  },
  {
    productType: 'Bouquet',
    keywords: ['bouquet', 'toss bouquet', 'bridal bouquet'],
  },
  {
    productType: 'Plant',
    keywords: ['plant', 'succulent', 'stem orchid', 'orchid garden', 'pothos', 'fern', 'bromeliad', 'garden', 'peace lily', 'anthurium'],
  },
];

/**
 * Match a description string to a product type based on keywords.
 * Returns the matched product type string, or null if no match.
 * Caller should default to 'Fresh Arrangement' when null is returned.
 *
 * @param {string} description - The item name/description text
 * @param {Array} availableTypes - Optional list of available placeholder product titles to validate against
 * @returns {string|null} Matched product type or null
 */
export function matchProductType(description, availableTypes = null) {
  if (!description) return null;

  const lowerDesc = description.toLowerCase();

  for (const { productType, keywords } of KEYWORD_MAP) {
    // If available types provided, only match if the product type exists as a placeholder
    if (availableTypes && !availableTypes.includes(productType)) continue;

    for (const keyword of keywords) {
      const pattern = new RegExp(`\\b${keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`);
      if (pattern.test(lowerDesc)) {
        return productType;
      }
    }
  }

  return null;
}
